<template>
    <div
        v-gtm:page="'G_Lobby'"
        class="home"
    >
        <TopBanner class="topBanner" />

        <InPlayBlock />
        <UpcomingBlock />
    </div>
</template>

<script lang="ts" setup>
    import TopBanner from '@/components/banner/TopBanner.vue';
    import InPlayBlock from '@/components/euroDisplay/home/InPlayBlock.vue';
    import UpcomingBlock from '@/components/euroDisplay/home/UpcomingBlock.vue';
</script>

<style lang="scss" scoped>
    .home {
        .topBanner {
            margin-bottom: var(--spacers-md);
        }
    }
</style>
